// PROPOSITO: quien esta dentro y con que rol. Persistido para que la app abra sin parpadeo.
// DEPENDENCIAS: zustand/persist, src/types/dominio.
// NO OBVIO: el rol que se guarda aqui SOLO decide que rutas se pintan. La proteccion de verdad
// vive en RLS: si alguien manipula este store, la base sigue sin devolverle nada ajeno. Una
// proteccion que se puede saltar hablandole a la API no es una proteccion.

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Perfil, Rol } from '@/types/dominio'

interface EstadoAuth {
  perfil: Perfil | null
  alumnaId: string | null
  cargando: boolean
  entrar: (perfil: Perfil, alumnaId: string | null) => void
  salir: () => void
  marcarCargado: () => void
}

export const usarAuth = create<EstadoAuth>()(
  persist(
    set => ({
      perfil: null,
      alumnaId: null,
      cargando: true,
      entrar: (perfil, alumnaId) => {
        set({ perfil, alumnaId, cargando: false })
      },
      salir: () => {
        set({ perfil: null, alumnaId: null, cargando: false })
      },
      marcarCargado: () => {
        set({ cargando: false })
      },
    }),
    {
      name: 'florfit.auth',
      partialize: estado => ({ perfil: estado.perfil, alumnaId: estado.alumnaId }),
    },
  ),
)

export function rolActual(): Rol | null {
  return usarAuth.getState().perfil?.rol ?? null
}
